import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IChecklistAfterIndicator, IChecklistBoolItem } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getChecklistAfterIndicatorList = (data: IDynamicTableParams) => {
  return instance()
    .post<IChecklistAfterIndicator[]>('/checkList/after/indicator/list', data)
    .then((response) => response.data);
};

export const getChecklistAfterIndicatorListAllNotDeleted = () => {
  return instance()
    .get<IChecklistBoolItem[]>('/checkList/after/indicator/listAllNotDeleted')
    .then((response) => response.data);
};

export const getChecklistAfterIndicatorAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/checkList/after/indicator/availableColumns')
    .then((response) => response.data);
};

export const getChecklistAfterIndicatorAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/checkList/after/indicator/availableGroupColumns')
    .then((response) => response.data);
};

export const loadChecklistAfterIndicator = (indicatorId: number) => {
  return instance()
    .get<IChecklistAfterIndicator>(`/checkList/after/indicator/load/${indicatorId}`)
    .then((response) => response.data);
};

export const createChecklistAfterIndicator = (checklistAfter: IChecklistAfterIndicator) => {
  return instance()
    .post<IChecklistAfterIndicator>(`/checkList/after/indicator/save`, checklistAfter)
    .then((response) => response.data);
};

export const updateChecklistAfterIndicator = (checklistAfter: IChecklistAfterIndicator) => {
  return instance()
    .post<IChecklistAfterIndicator>(`/checkList/after/indicator/${checklistAfter.indicatorId}/update`, checklistAfter)
    .then((response) => response.data);
};

export const archiveChecklistAfterIndicator = (indicatorId: number) => {
  return instance()
    .post('/checkList/after/indicator/archive', { indicatorId })
    .then((response) => response.data);
};

export const recoverChecklistAfterIndicator = (indicatorId: number) => {
  return instance()
    .post('/checkList/after/indicator/recover', { indicatorId })
    .then((response) => response.data);
};
